import { render } from "./admin-onboarding.vue?vue&type=template&id=41e9c7ca&scoped=true"
import script from "./admin-onboarding.vue?vue&type=script&lang=js"
export * from "./admin-onboarding.vue?vue&type=script&lang=js"

import "./admin-onboarding.vue?vue&type=style&index=0&id=41e9c7ca&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e9c7ca"],['__file',"src/components/admin-dashboard/ui/admin-onboarding.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "41e9c7ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41e9c7ca', __exports__)) {
    api.reload('41e9c7ca', __exports__)
  }
  
  module.hot.accept("./admin-onboarding.vue?vue&type=template&id=41e9c7ca&scoped=true", () => {
    api.rerender('41e9c7ca', render)
  })

}


export default __exports__